import { Outlet } from "react-router-dom";
// import SFChat from "../../components/elements/SalesforceChat";

const SalesforceChatVisibilityDecider = () => {
  // Salesforce chat disabled - configuration removed from .env

  return (
    <>
      <Outlet />
      {/* <SFChat visible={sfChatVisible} /> */}
    </>
  );
};

export default SalesforceChatVisibilityDecider;
